import UserError from './UserError.js'

const ERROR_CODE_NO_PERMISSION = 403
export default class UserNotLoggedInUserError extends UserError {
  constructor({message}) {
    super({message})
    this._message = message
  }

  toJSON() {
    return {
      message: this._message,
      code: ERROR_CODE_NO_PERMISSION
    }
  }
}
